export const CAMPAIGN_TAG = 'DCLMF23'
export const CAMPAING_TAB_ANIMATION_ENABLED = true
